import { useCallback } from 'react';
import { useRoutePath } from './useRoutePath';
export function useStepRoutePath(baseUrl) {
    const routePath = useRoutePath();
    return useCallback((stepSlug) => routePath(`${baseUrl}/${stepSlug}`), [routePath, baseUrl]);
}
